// Put your main state here
export default {
  show_overlay: false,
  status: "",
  token: localStorage.getItem("token") || "",
  client_customers: [{ value: "", text: "Cargando..." }],
  process: {
    markedRows: []
  },
  user: {
    ID_CLIENTE: "",
    ID_USUARIO: "",
    USUARIO: "",
    IMAGE: "",
    MENU: "",
    ACTIVO: false,
    DIRECTOR: false,
    STAFF: false,
    SUPERUSER: false,
    DETAILS: false,
    proforma_type: null,
    customComponents: {},
    waybill_custom_fields: {
      text_inputs: [
        {
          name: "input_1",
          max_length: 100
        },
        {
          name: "input_2",
          max_length: 100
        }
      ],
      select_inputs: [],
      number_inputs: [],
      datetime_inputs: [],
      boolean_inputs: [],
      date_inputs: []
    },
    content_custom_fields: {
      text_inputs: [],
      select_inputs: [],
      number_inputs: [],
      datetime_inputs: [],
      boolean_inputs: [],
      date_inputs: []
    }
  }
};
